import { createContext, useContext } from 'react';
import http from 'hub-http/clients/apiClient';
import { jsx as _jsx } from "react/jsx-runtime";
const HttpClientContext = /*#__PURE__*/createContext(http);
export function useHttpClientContext() {
  return useContext(HttpClientContext);
}
export function HttpClientProvider({
  httpClient = http,
  children
}) {
  return /*#__PURE__*/_jsx(HttpClientContext.Provider, {
    value: httpClient,
    children: children
  });
}